import { CatchitEnvironment } from '../app/core/interfaces/environment.interface';

export const environment: CatchitEnvironment = {
  production: false,
  version: '1.0.0-#144',
  apiBaseUrl: 'https://apis.dev.auckland.ac.nz/catchit/v1', // confirm exact path with deployment config
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoClientId: '7l8npldglefhe8ou4naq0vs79n', //Your consumer's client ID found in /<env>/<project-name>/<project-name>-ACF-id
    cognitoUserPoolId: 'ap-southeast-2_4POM5hFXI',
    cognitoDomain: 'catchit-nonprod',
    redirectUri: 'https://d3uzkiw9cspu36.cloudfront.net', //URL for Cognito to redirect to after login. Matching value should be set in your app client configuration on Cognito (manual step)
    logoutUri: 'https://www.auckland.ac.nz/en/about-us/about-the-university/identity-and-access-management/single-sign-on/verify-logout.html', //URL for Cognito to redirect to after logout. Matching value should be set in your app client configuration on Cognito (manual step)
    scopes: 'openid profile https://auth.auckland.ac.nz/api-catchit-v1:read https://auth.auckland.ac.nz/api-catchit-v1:write', //Scopes which will be included in your access token. Should always include openid & profile + any other API specific scopes required.
    codeChallengeMethod: 'S256',
    identityProvider: 'UoATestIDP', // Skips the Cognito Hosted UI provider picker, going straight to UoA SSO
  },
  privateUrlKeyWords: {
    // optional: true + publicPaths means @uoa/auth's AuthInterceptor won't force a login
    // redirect for /catchit/v1/public/** (sign-up, forgotten-password, etc.) when there's
    // no session - everything else under this domain still mandatorily requires a token,
    // unchanged. Without this, AuthInterceptor (a separate mechanism from
    // CatchitHttpService's own auth handling) redirected every logged-out visitor to
    // Cognito's hosted login the moment they submitted the public Sign Up form, regardless
    // of the backend/gateway correctly allowing the request through unauthenticated.
    whoNeedBearerToken: [{ url: 'apis.dev.auckland.ac.nz', optional: true, publicPaths: ['catchit/v1/public'] }],
  },

  // Catch IT specific configuration
  testBanner: 'TEST ENVIRONMENT: this is the Catch IT test system. Anything entered here is for testing only.',
  shinyBaseUrl: 'https://shiny.catchit.dev.auckland.ac.nz/',  //TODO
  feedbackEmail: 'catchitgroup@gmail.com',
  legalUrl: 'https://www.auckland.ac.nz/',
  // Define Cognito custom attributes needed for Catch IT users
  cognitoCustomAttributes: {
    areaId: 'custom:catchit_area_id', // User's area ID
    lineId: 'custom:catchit_line_id', // User's line ID
    paid: 'custom:catchit_paid', // Payment status
    showWelcome: 'custom:catchit_welcome', // Show welcome flag
  },
  // Define Cognito group names for role-based access, in priority order (first match wins)
  // 'admin' is intentionally absent here - it's not Cognito-group-based. Area admin
  // status is DB-driven (see CognitoUserService's adminAreas lookup) and is applied
  // on top of whatever role resolves from these groups.
  allowedGroups: [
    { group: 'CatchitOwner_users', role: 'super-admin' },
    { group: 'Catchit_users', role: 'user' },
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
